module.exports = __webpack_public_path__ + "static/media/orchard.e5c05106.jpg";